import api from '../Api';

class SocketService {
  constructor() {
    this.socketBaseUrl = null;
    this.isInitialized = false;
    this.initializationPromise = null;
  }

  /**
   * Fetch socket base URL from the API
   * @returns {Promise<string>} The socket base URL
   */
  async fetchSocketBaseUrl() {
    try {

      const response = await api.get('/Application/socket');
      
      if (response.data) {
        this.socketBaseUrl = response.data;
        this.isInitialized = true;

        return this.socketBaseUrl;
      } else {
        throw new Error('No socket URL received from API');
      }
    } catch (error) {

      
      // Fallback to default URL if API call fails
      const fallbackUrl = process.env.REACT_APP_API_URL.replace("api/v1/", "");

      this.socketBaseUrl = fallbackUrl;
      this.isInitialized = true;
      return fallbackUrl;
    }
  }

  /**
   * Get socket base URL (initialize if needed)
   * @returns {Promise<string>} The socket base URL
   */
  async getSocketBaseUrl() {
    if (this.isInitialized) {
      return this.socketBaseUrl;
    }

    if (this.initializationPromise) {
      return this.initializationPromise;
    }

    this.initializationPromise = this.fetchSocketBaseUrl();
    return this.initializationPromise;
  }

  /**
   * Get MainHub URL
   * @returns {Promise<string>} The MainHub URL
   */
  async getMainHubUrl() {
    const baseUrl = await this.getSocketBaseUrl();
    // Ensure proper URL concatenation with forward slash
    const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    return `${normalizedBaseUrl}MainHub`;
  }

  /**
   * Get ChatHub URL
   * @returns {Promise<string>} The ChatHub URL
   */
  async getChatHubUrl() {
    const baseUrl = await this.getSocketBaseUrl();
    // Ensure proper URL concatenation with forward slash
    const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    return `${normalizedBaseUrl}ChatHub`;
  }

  /**
   * Reset the service (useful for testing or re-initialization)
   */
  reset() {
    this.socketBaseUrl = null;
    this.isInitialized = false;
    this.initializationPromise = null;
  }

  /**
   * Get current socket base URL without initialization
   * @returns {string|null} The current socket base URL or null if not initialized
   */
  getCurrentSocketBaseUrl() {
    return this.socketBaseUrl;
  }

  /**
   * Check if the service is initialized
   * @returns {boolean} True if initialized
   */
  isServiceInitialized() {
    return this.isInitialized;
  }
}

// Create a singleton instance
const socketService = new SocketService();

export default socketService; 